import { render, staticRenderFns } from "./build-report.vue?vue&type=template&id=19af3baa&"
import script from "./build-report.vue?vue&type=script&lang=js&"
export * from "./build-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports